<app-update></app-update>
<app-header class="sticky-top shadow-sm"> </app-header>

<div class="page">
  <app-menu></app-menu>
  <main>
    <router-outlet></router-outlet>
    @if (loading$ | async) {
      <div class="d-flex justify-content-center m-4">
        <app-spinner></app-spinner>
      </div>
    }
    <app-alert></app-alert>
    <app-indicator></app-indicator>
    <app-koekjes></app-koekjes>
  </main>
</div>
